export const shouldShowAuctionAccessDealerId = ({ isOrganicSignup, isAfcFastPath, isFastPath, isAffiliatePartner }) =>
	isOrganicSignup || isAfcFastPath || isFastPath || isAffiliatePartner;

export const shouldRequireAuctionAccessDealerId = ({ isAfcFastPath, driversLicenseInStepZero }) =>
	isAfcFastPath && !driversLicenseInStepZero;

export const shouldUseDriversLicenseFallbackForAuctionAccessDealerId = ({ isAfcFastPath, driversLicenseInStepZero }) =>
	isAfcFastPath && driversLicenseInStepZero;
